module.exports = ".mat-dialog-container {\n    padding: 45px;\n}"